// src/components/products/ProductSingle.js

import { Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductsData from './productsData';
import Navbar from '../../components/Navbar/Navbar';





import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg';
import Phone from '../../images/telephone.svg';
// import simg1 from '../../images/service-single/im-1.jpg';
// import simg2 from '../../images/service-single/im-2.jpg';
import SideProduct from './SideProduct'; // adjust path based on your folder structure

import LenisSmoothScroll from '../../components/lenissmoothscroll/LenisSmoothScroll';
import '../../css/product.css';


// Helper to extract Key Features HTML from productDetails.content
function extractKeyFeatures(content) {
  const match = content.match(/(<h4>Key Features<\/h4>[\s\S]*?<\/ul>)/i);
  return match ? match[1] : null;
}

// Helper to extract the <p><strong>ThinkBig ...</strong> ...</p> summary after Product Overview
function extractProductSummary(content) {
  // Try to match <p><strong>ThinkBig ...</strong> ...</p> that comes after Product Overview
  const match = content.match(/<h4>Product Overview<\/h4>\s*<p>.*?<\/p>\s*<p>(<strong>ThinkBig[\s\S]*?<\/p>)/i);
  if (match && match[1]) return match[1];
  // fallback: match any <p><strong>ThinkBig ...</strong> ...</p>
  const fallback = content.match(/(<p><strong>ThinkBig[\s\S]*?<\/p>)/i);
  return fallback ? fallback[1] : null;
}

// Reuse accordion if FAQ same
// import ProductSidebar from './ProductSidebar'; // Optional

const ProductSingle = () => {
  const { slug } = useParams();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);
  const productDetails = ProductsData.find(item => item.slug === slug);

  if (!productDetails) {
    return <div className="text-center mt-5">Product not found!</div>;
  }

  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={productDetails.title} pagesub={'Product'} />

      <section className="service-single-section section-padding">
        <div className="container">
          <div className="row" >
            {/* Product Content */}
            <div className="col-lg-8 col-md-12">
              <div className="service-single-wrap">
                <div className="service-single-content">
                  <img src={productDetails.sSImg} alt={productDetails.title} />
                  <div className="service-single-content-des">
                    <h2>{productDetails.title}</h2>
                    {/* Product summary paragraph below the topic */}
                    {extractProductSummary(productDetails.content) && (
                      <div className="product-summary mt-3 "dangerouslySetInnerHTML={{ __html: extractProductSummary(productDetails.content) }} />
                    )}
                    {/* Key Features below the summary */}
                    {extractKeyFeatures(productDetails.content) && (
                      <div className="product-key-features mt-4" dangerouslySetInnerHTML={{ __html: extractKeyFeatures(productDetails.content) }} />
                    )}
                  </div>
                </div>

                {/* FAQ Accordion */}
                <div className="benefits-section">
                  {/* <h2></h2> */}
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <div className="benefits-item">
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Product Content Sidebar */}
            <div className="col-lg-4 col-12 mt-4 mt-lg-0">
             <SideProduct content={productDetails.content} slug={productDetails.slug} />

            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
      < LenisSmoothScroll />
    
    </Fragment>
  );
};

export default ProductSingle;
